import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfessionalStateService {
  private _selected = new BehaviorSubject<any>(null);
  private _list     = new BehaviorSubject<any[]>([]);
  private _loading  = new BehaviorSubject<boolean>(true);

  readonly selected$  = this._selected.asObservable();
  readonly list$      = this._list.asObservable();
  readonly loading$   = this._loading.asObservable();
  readonly openModal$ = new Subject<void>();

  get selected(): any    { return this._selected.value; }
  get list(): any[]      { return this._list.value; }
  get loading(): boolean { return this._loading.value; }

  setList(list: any[]): void   { this._list.next(list); this._loading.next(false); }
  setLoading(v: boolean): void { this._loading.next(v); }
  select(p: any): void         { this._selected.next(p); }
  addToList(p: any): void      { this._list.next([...this._list.value, p]); }
  requestModal(): void         { this.openModal$.next(); }
}
